module.exports = ":host .carousel .carousel-inner img {\n  height: 400px;\n  -o-object-fit: cover;\n     object-fit: cover; }\n"